// User types
export interface User {
  id: string;
  email: string;
  name?: string;
  avatarUrl?: string;
  createdAt: string;
}

export interface Profile {
  id: string;
  userId: string;
  profiles: ProfileType[];
  // User data (from user table via join)
  name?: string;
  title?: string; // Job title (e.g., "Software Engineer")
  industry?: string;
  role?: string; // User role (e.g., "admin")
  // Profile data
  preferences?: Record<string, unknown>;
  onboardingCompleted: boolean;
  createdAt: string;
  updatedAt: string;
}

// Role type for access control
export type UserRole = 'admin' | 'user';

// Helper to check if user is admin
export function isAdminRole(role?: string): boolean {
  return role === 'admin';
}

export type ProfileType = 'engineer' | 'product_manager' | 'designer' | 'founder' | 'generalist';

// Content types
export interface Content {
  id: string;
  title: string;
  titleOriginal: string;
  summary: string;
  body?: string;
  bodyOriginal?: string;
  theme: ContentTheme;
  author: string;
  source: string;
  sourceUrl: string;
  url?: string;
  takeaways?: string[];
  readingTimeMinutes?: number;
  publishedAt: string;
  createdAt: string;
}

export type ContentTheme =
  | 'ai_ml'
  | 'engineering'
  | 'product'
  | 'design'
  | 'startup'
  | 'leadership'
  | 'career';

// Feed types
export interface FeedItem {
  content: Content;
  score: number;
  tier: 'primary' | 'secondary';
  userState: UserContentState;
}

export interface UserContentState {
  isLiked: boolean;
  isSaved: boolean;
  isDismissed: boolean;
  readAt?: string;
}

// Interaction types
export type InteractionType = 'like' | 'save' | 'dismiss' | 'read' | 'feedback';

export interface Interaction {
  id: string;
  userId: string;
  contentId: string;
  type: InteractionType;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

// Comment types
export interface Comment {
  id: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  userName: string;
}

// API types
export interface ApiError {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    hasMore: boolean;
  };
}
